const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHatsu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M409.81 440.814c34.623 13.502 72.538 107.465 100.967 181.52 1.39 3.012 2.237 6.28 5.698 8.07 25.981 14.66 56.136 36.473 68.7 46.744 23.445 16.6 35.69 5.68 29.306-10.12-4.824-12.172-23.578-40.29-27.773-49.287-5.349-9.978-19.29-21.423-37.287-34.999-35.855-25.864-57.629-82.487-122.287-162.606-3.152-2.99-19.008 14.443-17.324 20.678",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.617 432.983C345.233 543.325 295.68 606.33 219.651 653.485c-21.022 14.302-25.419 2.34-9.192-10.607 93.496-76.129 113.842-140.11 192.052-224.68z",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.083 388.142c-30.085 27.275-48.126 58.97-85.147 77.978-16.656 10.416-17.19 22.166 4.093 19.502 34.748-5.57 73.281-26.555 101.81-43.312 24.084-14.969 21.092-89.467-20.756-54.168M473.088 378.629c-8.021 26.87-15.132 47.69-31.253 75.39l18.53 17.015c25.674-51.4 34.479-76.259 47.315-80.033 4.272-2.32 1.633-10.047-.565-14.073-4.613-8.45-9.26-18.302-15.067-24.312-12.598-12.07-14.785 14.812-18.96 26.013M525.866 454.912c-5.54-6.01-11.798-3.892-16.343 6.767-4.08 9.962-25.347 37.038-51.454 62.217-8.908 9.082-.997 17.81 13.054 7.928 23.51-22.225 42.38-39.496 56.809-42.844 6.557-1.292 18.036 2.916 16.748-6.01-2.328-10.736-9.922-19.256-18.814-28.058M291.14 495.744c-18.984-18.224-34.161-11.582-14.203 15.653 41.324 56.91 66.675 67.774 56.668 88.652l19.17.006c10.562-11.407 6.782-4.015-.957-38.694-2.206-9.886-31.089-24.826-60.677-65.616z",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.32 554.817-27.34 26.172c34.688-2.843 50.371-.452 85.667-20.679 24.818-13.682 9.359-25.978-4.469-21.25-29.986 12.626-28.043 11.235-53.858 15.757M278.308 635.425c-7.825 4.639-17.68-3.49-12.315 8.803 5.328 9.292 16.155 8.273 26.718 4.4 9.136-3.388 71.715-51.798 112.077-57.506l2.144-27.028c-65.508 22.16-120.91 66.042-128.624 71.33",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.866 485.782c-3.191-3.716-11.42-9.252-15.636 4.08-.96 6.266 1.536 12.493.647 22.124-4.212 57.884-16.98 75.42-21.18 99.27-1.935 12.712 3.748 21.592 12.919 3.337 6.851-20.535 14.513-35.096 37.882-94.819 1.556-10.546-4.223-22.313-14.632-33.992M352.09 608.31l-15.287 8.074c9.548 22.703-13.156 103.217-30.129 101.91-20.396-2.125-40.398-17.087-55.567-28l-6.87.63c16.88 27.585 39.198 59.947 63.667 64.405 7.704 1.22 22.747-8.454 26.735-15.058 29.58-60.787 39.331-91.75 33.128-109.085-2.842-7.945-12.716-13.94-15.677-22.877",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.59 659.103-2.102-18.395c-37.057 12.706-65.78 33.735-94.641 38.107-11.477 1.54-20.163-2.306-28.065-7.632-5.321-4.257-7.888-.637-6.817 4.927 2.993 11.732 4.715 11.44 12.11 17.205 6.914 4.259 12.474 4.556 23.638 3.786 28.294-2.22 64.481-27.745 95.877-37.998M404.433 591.79l-8.73 26.948c32.17-4.284 49.87-6.046 78.518-16.541 22.25-16.457 10.383-20.907-3.4-22.333-39.388 3.283-26.08 6.797-66.388 11.925",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.25 600.2 420 606.182c-.493 41.256.968 49.103-3.35 59.747-13.116 25.028-2.419 29.64-63.805 75.314-8.593 6.223-.715 18.325 9.282 16.442 42.483-7.097 79.34-32.537 81.813-42.051 5.79-28.219.609-70.232-2.69-115.434",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.046 652.395-1.24 24.7c-5.026-1.645 99.955-7.849 163.567-3.19 8.388-.315 20.892.174 18.955-7.291-14.302-21.14-22.105-23.509-30.753-24.522-2.99.263-8.586 3.053-12.608 2.702-25.404 2.159-87.694 6.193-137.921 7.601M467.47 707.996c16.456 11.81 23.18 23.603 27.442 47.65.48 2.71-.54 7.364 7.273 8.723 28.718 5 57.747-8.734 60.298-22.096 1.6-27.282-51.933-50.902-89.276-47.748-7.694 1.29-9.128 11.019-5.737 13.47",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-140.43 -204.07)scale(.71142)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatsu);
export default __webpack_public_path__ + "static/media/Hatsu.55ca3fd007aaeeb194b972a8703800c1.svg";
export { ForwardRef as ReactComponent };